import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.ip.market.documents');
import { OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

type DocumentViewMode = 'history' | 'compose';

@Component({
    selector: 'wiz-component-ip-market-documents',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.ip.market.documents/view.scss */
:host {
  display: block;
}

.ipt-document-panel {
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  background: #fff;
}

.ipt-document-panel__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.ipt-document-panel__eyebrow {
  color: #0e7490;
  font-size: 0.625rem;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.ipt-document-panel__header h3 {
  margin-top: 0.2rem;
  color: #0f172a;
  font-size: 0.8125rem;
  font-weight: 700;
  line-height: 1.35;
}

.ipt-document-panel__header p:last-child {
  margin-top: 0.3rem;
  color: #64748b;
  font-size: 0.6875rem;
  line-height: 1.5;
}

.ipt-document-panel__new-button {
  flex: 0 0 auto;
  min-height: 2rem;
  padding: 0.4rem 0.75rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.375rem;
  color: #475569;
  background: #fff;
  font-size: 0.6875rem;
  font-weight: 700;
}

.ipt-document-panel__new-button:hover:not(:disabled) {
  border-color: #94a3b8;
  background: #f8fafc;
}

.ipt-document-panel__status,
.ipt-document-panel__error {
  margin: 0.875rem 1.25rem 0;
  font-size: 0.6875rem;
}

.ipt-document-panel__status {
  color: #64748b;
}

.ipt-document-panel__error {
  padding: 0.75rem;
  border: 1px solid #fecdd3;
  border-radius: 0.5rem;
  color: #be123c;
  background: #fff1f2;
}

.ipt-document-panel__error button {
  margin-top: 0.4rem;
  font-weight: 700;
  text-decoration: underline;
}

.ipt-document-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.25rem;
}

.ipt-document-field {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 0.35rem;
  color: #475569;
  font-size: 0.6875rem;
  font-weight: 700;
}

.ipt-document-field input,
.ipt-document-field select,
.ipt-document-field textarea {
  width: 100%;
  min-width: 0;
  border: 1px solid #cbd5e1;
  border-radius: 0.5rem;
  color: #1e293b;
  background: #fff;
  font-size: 0.75rem;
  font-weight: 500;
  outline: none;
  transition: border-color 150ms ease, box-shadow 150ms ease;
}

.ipt-document-field input,
.ipt-document-field select {
  height: 2.25rem;
  padding: 0 0.75rem;
}

.ipt-document-field select {
  padding-right: 2rem;
}

.ipt-document-field textarea {
  min-height: 5.5rem;
  padding: 0.65rem 0.75rem;
  line-height: 1.55;
  resize: vertical;
}

.ipt-document-field input:focus,
.ipt-document-field select:focus,
.ipt-document-field textarea:focus {
  border-color: #0891b2;
  box-shadow: 0 0 0 3px rgba(8, 145, 178, 0.1);
}

.ipt-document-field input::placeholder,
.ipt-document-field textarea::placeholder {
  color: #94a3b8;
  font-weight: 400;
}

.ipt-document-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.75rem;
}

.ipt-quote-toggle {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.625rem;
  background: #fff;
  cursor: pointer;
}

.ipt-quote-toggle:has(input:checked) {
  border-color: #a5d8df;
  background: #f0fafa;
}

.ipt-quote-toggle > input {
  width: 1rem;
  height: 1rem;
  flex: 0 0 auto;
  accent-color: #0e7490;
}

.ipt-quote-toggle__copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 0.15rem;
}

.ipt-quote-toggle__copy strong {
  color: #1e293b;
  font-size: 0.75rem;
  font-weight: 700;
}

.ipt-quote-toggle__copy small {
  color: #64748b;
  font-size: 0.625rem;
  line-height: 1.45;
}

.ipt-quote-editor {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.625rem;
  background: #f8fafc;
}

.ipt-quote-editor__header,
.ipt-document-attachment__header,
.ipt-document-history__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.ipt-quote-editor__header h4,
.ipt-document-attachment__header h4,
.ipt-document-history__header h4 {
  color: #1e293b;
  font-size: 0.75rem;
  font-weight: 800;
}

.ipt-quote-editor__header p,
.ipt-document-attachment__header p {
  margin-top: 0.15rem;
  color: #64748b;
  font-size: 0.625rem;
  line-height: 1.45;
}

.ipt-quote-editor__header > strong {
  flex: 0 0 auto;
  color: #0f172a;
  font-size: 0.8125rem;
  font-weight: 800;
}

.ipt-quote-items {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.ipt-quote-item {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 0.875rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  background: #fff;
}

.ipt-quote-item__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.ipt-quote-item__header span {
  color: #64748b;
  font-size: 0.625rem;
  font-weight: 800;
  letter-spacing: 0.04em;
}

.ipt-quote-item__header button {
  color: #e11d48;
  font-size: 0.625rem;
  font-weight: 700;
}

.ipt-quote-item__header button:disabled {
  color: #cbd5e1;
}

.ipt-quote-item__amounts {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.625rem;
}

.ipt-document-attachment {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 0.875rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.625rem;
  background: #f8fafc;
}

.ipt-document-attachment__header > span,
.ipt-document-history__header > span {
  flex: 0 0 auto;
  color: #64748b;
  font-size: 0.625rem;
  font-weight: 700;
}

.ipt-document-attachment__controls {
  display: grid;
  grid-template-columns: minmax(10rem, 0.28fr) minmax(0, 1fr);
  align-items: end;
  gap: 0.75rem;
}

.document-upload-field {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 0.35rem;
}

.document-upload-label {
  color: #475569;
  font-size: 0.6875rem;
  font-weight: 700;
}

.document-file-picker {
  display: flex;
  width: 100%;
  min-width: 0;
  height: 2.25rem;
  align-items: stretch;
  overflow: hidden;
  border: 1px solid #cbd5e1;
  border-radius: 0.5rem;
  background: #fff;
  cursor: pointer;
  transition: border-color 150ms ease, box-shadow 150ms ease;
}

.document-file-picker:hover {
  border-color: #67e8f9;
}

.document-file-picker:focus-within {
  border-color: #0891b2;
  box-shadow: 0 0 0 3px rgba(8, 145, 178, 0.1);
}

.document-file-input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap;
}

.document-file-button {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.4rem;
  padding: 0 0.75rem;
  border-right: 1px solid #e2e8f0;
  color: #0e7490;
  background: #ecfeff;
  font-size: 0.6875rem;
  font-weight: 700;
  white-space: nowrap;
}

.document-file-button i {
  font-size: 0.6875rem;
}

.document-file-status {
  display: flex;
  min-width: 0;
  flex: 1 1 auto;
  align-items: center;
  overflow: hidden;
  padding: 0 0.75rem;
  color: #64748b;
  font-size: 0.6875rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

fieldset:disabled .document-file-picker {
  border-color: #e2e8f0;
  background: #f8fafc;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 0.7;
}

.ipt-document-files {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.ipt-document-files li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.625rem 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  background: #fff;
  font-size: 0.6875rem;
}

.ipt-document-files a {
  min-width: 0;
  overflow-wrap: anywhere;
  color: #0e7490;
  font-weight: 600;
}

.ipt-document-files button {
  flex: 0 0 auto;
  color: #e11d48;
  font-weight: 700;
}

.ipt-document-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 0 1.25rem 1.25rem;
}

.ipt-document-button {
  display: inline-flex;
  min-height: 2.25rem;
  align-items: center;
  justify-content: center;
  padding: 0.45rem 0.875rem;
  border-radius: 0.375rem;
  font-size: 0.6875rem;
  font-weight: 700;
  transition: border-color 150ms ease, background-color 150ms ease;
}

.ipt-document-button--secondary {
  align-self: flex-start;
  border: 1px solid #cbd5e1;
  color: #475569;
  background: #fff;
}

.ipt-document-button--secondary:hover:not(:disabled) {
  background: #f8fafc;
}

.ipt-document-button--preview {
  border: 1px solid #a5d8df;
  color: #0e7490;
  background: #f0fafa;
}

.ipt-document-button--primary {
  border: 1px solid #0e7490;
  color: #fff;
  background: #0e7490;
}

.ipt-document-button--primary:hover:not(:disabled) {
  background: #155e75;
}

.ipt-document-button:disabled,
.ipt-document-panel__new-button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.ipt-document-sent {
  display: inline-flex;
  min-height: 2.25rem;
  align-items: center;
  padding: 0 0.75rem;
  border-radius: 0.375rem;
  color: #047857;
  background: #ecfdf5;
  font-size: 0.6875rem;
  font-weight: 800;
}

.ipt-document-history {
  padding: 1rem 1.25rem;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
}

.ipt-document-history__empty {
  margin-top: 0.5rem;
  color: #94a3b8;
  font-size: 0.6875rem;
}

.ipt-document-history__item {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 0.5rem;
  padding: 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  text-align: left;
  background: #fff;
}

.ipt-document-history__item:hover:not(:disabled) {
  border-color: #a5d8df;
  background: #f8fdff;
}

.ipt-document-history__item > span {
  min-width: 0;
}

.ipt-document-history__item strong {
  color: #1e293b;
  font-size: 0.6875rem;
}

.ipt-document-history__item em {
  margin-left: 0.5rem;
  color: #0e7490;
  font-size: 0.625rem;
  font-style: normal;
  font-weight: 700;
}

.ipt-document-history__item small {
  flex: 0 0 auto;
  color: #94a3b8;
  font-size: 0.625rem;
}

@media (max-width: 640px) {
  .ipt-document-panel__header,
  .ipt-quote-editor__header,
  .ipt-document-attachment__header,
  .ipt-document-history__item {
    align-items: flex-start;
  }
  .ipt-document-form {
    padding: 1rem;
  }
  .ipt-document-grid,
  .ipt-quote-item__amounts,
  .ipt-document-attachment__controls {
    grid-template-columns: 1fr;
  }
  .ipt-document-actions {
    padding: 0 1rem 1rem;
  }
  .ipt-document-button {
    width: 100%;
  }
  .ipt-document-history__item {
    flex-direction: column;
    gap: 0.25rem;
  }
}
.ipt-document-common {
  overflow: hidden;
  border: 1px solid #dbe4ea;
  border-radius: 0.75rem;
  background: #f8fafc;
}

.ipt-document-common__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.85rem 1rem;
  border-bottom: 1px solid #e2e8f0;
  background: #fff;
}

.ipt-document-common__header > div {
  display: flex;
  align-items: center;
  gap: 0.55rem;
}

.ipt-document-common__header h4 {
  color: #334155;
  font-size: 0.75rem;
  font-weight: 800;
}

.ipt-document-common__header p {
  max-width: 27rem;
  color: #64748b;
  font-size: 0.625rem;
  line-height: 1.45;
  text-align: right;
}

.ipt-document-common__badge {
  display: inline-flex;
  min-height: 1.35rem;
  align-items: center;
  padding: 0 0.45rem;
  border: 1px solid #cbd5e1;
  border-radius: 999px;
  color: #64748b;
  background: #f8fafc;
  font-size: 0.5625rem;
  font-weight: 800;
}

.ipt-document-common__fields {
  display: grid;
  grid-template-columns: minmax(12rem, 0.35fr) minmax(0, 0.65fr);
  gap: 0.85rem;
  padding: 1rem;
}

.ipt-delivery-section-list {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.ipt-delivery-section {
  position: relative;
  overflow: hidden;
  border: 1px solid #dbe4ea;
  border-left-width: 0.25rem;
  border-radius: 0.8rem;
  background: #fff;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.035);
}

.ipt-delivery-section--quote.is-enabled {
  border-color: #a5d8df;
  border-left-color: #0891b2;
  box-shadow: 0 10px 26px rgba(8, 145, 178, 0.07);
}

.ipt-delivery-section--attachment.is-enabled {
  border-color: #c7d2fe;
  border-left-color: #4f46e5;
  box-shadow: 0 10px 26px rgba(79, 70, 229, 0.07);
}

.ipt-delivery-section__header {
  display: flex;
  min-height: 4.3rem;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.9rem 1rem 0.9rem 1.2rem;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.ipt-delivery-section--quote.is-enabled .ipt-delivery-section__header {
  background: #ecfeff;
}

.ipt-delivery-section--attachment.is-enabled .ipt-delivery-section__header {
  background: #eef2ff;
}

.ipt-delivery-section__identity {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 0.75rem;
}

.ipt-delivery-section__identity h4 {
  color: #0f172a;
  font-size: 0.8125rem;
  font-weight: 800;
}

.ipt-delivery-section__identity p {
  margin-top: 0.2rem;
  color: #64748b;
  font-size: 0.625rem;
  line-height: 1.45;
}

.ipt-delivery-section__number {
  display: inline-flex;
  width: 2rem;
  height: 2rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 0.55rem;
  color: #64748b;
  background: #e2e8f0;
  font-size: 0.625rem;
  font-weight: 900;
  letter-spacing: 0.04em;
}

.ipt-delivery-section--quote.is-enabled .ipt-delivery-section__number {
  color: #fff;
  background: #0891b2;
}

.ipt-delivery-section--attachment.is-enabled .ipt-delivery-section__number {
  color: #fff;
  background: #4f46e5;
}

.ipt-delivery-choice {
  display: inline-flex;
  min-height: 2rem;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.45rem;
  padding: 0.35rem 0.65rem;
  border: 1px solid #cbd5e1;
  border-radius: 999px;
  color: #64748b;
  background: #fff;
  cursor: pointer;
  font-size: 0.625rem;
  font-weight: 800;
}

.ipt-delivery-choice.is-selected {
  border-color: #67e8f9;
  color: #0e7490;
  background: #ecfeff;
}

.ipt-delivery-choice i {
  width: 0.9rem;
  flex: 0 0 auto;
  font-size: 0.9rem;
  text-align: center;
}

.ipt-delivery-choice:not(.is-selected) i {
  color: #94a3b8;
}

.ipt-delivery-section__count {
  display: inline-flex;
  min-width: 3.25rem;
  min-height: 2rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 1px solid #c7d2fe;
  border-radius: 999px;
  color: #4338ca;
  background: #eef2ff;
  font-size: 0.625rem;
  font-weight: 800;
}

.ipt-delivery-section .ipt-quote-editor,
.ipt-delivery-section .ipt-document-attachment {
  padding: 1rem 1.2rem 1.2rem;
  border: 0;
  border-radius: 0;
  background: #fff;
}

.ipt-delivery-section .ipt-document-attachment {
  gap: 0.85rem;
}

.ipt-delivery-section__empty {
  padding: 1rem 1.2rem 1.1rem;
  color: #94a3b8;
  background: #fff;
  font-size: 0.6875rem;
}

.ipt-delivery-section__empty--attachment {
  padding: 0.7rem 0.8rem;
  border: 1px dashed #cbd5e1;
  border-radius: 0.5rem;
  background: #f8fafc;
}

.ipt-document-actions {
  margin-top: 0.25rem;
  padding-top: 1rem;
  border-top: 1px solid #e2e8f0;
}

@media (max-width: 760px) {
  .ipt-document-common__header,
  .ipt-delivery-section__header {
    align-items: flex-start;
    flex-direction: column;
  }
  .ipt-document-common__header p {
    max-width: none;
    text-align: left;
  }
  .ipt-document-common__fields {
    grid-template-columns: 1fr;
  }
  .ipt-delivery-choice,
  .ipt-delivery-section__count {
    margin-left: 2.75rem;
  }
}
.ipt-document-detail {
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
  padding: 1.25rem;
  border-bottom: 1px solid #e2e8f0;
  background: #fff;
}

.ipt-document-detail__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem;
  border: 1px solid #bae6fd;
  border-radius: 0.75rem;
  background: #ecfeff;
}

.ipt-document-detail__status-line {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  color: #64748b;
  font-size: 0.625rem;
}

.ipt-document-detail__status {
  display: inline-flex;
  min-height: 1.45rem;
  align-items: center;
  padding: 0 0.5rem;
  border-radius: 999px;
  color: #047857;
  background: #d1fae5;
  font-weight: 800;
}

.ipt-document-detail__top h4 {
  margin-top: 0.55rem;
  color: #0f172a;
  font-size: 0.95rem;
  font-weight: 800;
}

.ipt-document-detail__top p {
  margin-top: 0.25rem;
  color: #0e7490;
  font-size: 0.6875rem;
  font-weight: 700;
}

.ipt-document-detail__message {
  padding: 0.9rem 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.7rem;
  background: #f8fafc;
}

.ipt-document-detail__message > span,
.ipt-document-detail__note > span {
  color: #64748b;
  font-size: 0.625rem;
  font-weight: 800;
}

.ipt-document-detail__message p,
.ipt-document-detail__note p {
  margin-top: 0.4rem;
  color: #334155;
  font-size: 0.75rem;
  line-height: 1.6;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.ipt-document-detail__section {
  overflow: hidden;
  border: 1px solid #dbe4ea;
  border-left-width: 0.25rem;
  border-radius: 0.75rem;
  background: #fff;
}

.ipt-document-detail__section--quote {
  border-color: #a5d8df;
  border-left-color: #0891b2;
}

.ipt-document-detail__section--files {
  border-color: #c7d2fe;
  border-left-color: #4f46e5;
}

.ipt-document-detail__section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.85rem 1rem;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.ipt-document-detail__section-header > div {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 0.65rem;
}

.ipt-document-detail__section-header h5 {
  color: #0f172a;
  font-size: 0.75rem;
  font-weight: 800;
}

.ipt-document-detail__section-header p {
  margin-top: 0.12rem;
  color: #64748b;
  font-size: 0.625rem;
}

.ipt-document-detail__section-header > strong {
  flex: 0 0 auto;
  color: #0f172a;
  font-size: 0.8125rem;
  font-weight: 800;
}

.ipt-document-detail__section-number {
  display: inline-flex;
  width: 1.75rem;
  height: 1.75rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 0.45rem;
  color: #fff;
  background: #0891b2;
  font-size: 0.5625rem;
  font-weight: 900;
}

.ipt-document-detail__section--files .ipt-document-detail__section-number {
  background: #4f46e5;
}

.ipt-document-detail__meta {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.75rem;
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #e2e8f0;
}

.ipt-document-detail__meta dt {
  color: #94a3b8;
  font-size: 0.625rem;
}

.ipt-document-detail__meta dd {
  margin-top: 0.2rem;
  color: #334155;
  font-size: 0.6875rem;
  font-weight: 700;
  overflow-wrap: anywhere;
}

.ipt-document-detail__quote-items {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  padding: 0.9rem 1rem;
}

.ipt-document-detail__quote-item {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 1rem;
  padding: 0.65rem 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  background: #f8fafc;
}

.ipt-document-detail__quote-item > span {
  color: #1e293b;
  font-size: 0.6875rem;
  font-weight: 700;
  overflow-wrap: anywhere;
}

.ipt-document-detail__quote-item small {
  color: #64748b;
  font-size: 0.625rem;
}

.ipt-document-detail__quote-item strong {
  color: #0e7490;
  font-size: 0.6875rem;
  white-space: nowrap;
}

.ipt-document-detail__note {
  margin: 0 1rem 0.9rem;
  padding: 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  background: #f8fafc;
}

.ipt-document-detail__section > .ipt-document-button {
  margin: 0 1rem 1rem;
}

.ipt-document-detail__files {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.9rem 1rem 1rem;
}

.ipt-document-detail__files li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.7rem 0.8rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  background: #f8fafc;
}

.ipt-document-detail__files li > div {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 0.55rem;
}

.ipt-document-detail__files span {
  flex: 0 0 auto;
  padding: 0.2rem 0.4rem;
  border-radius: 0.3rem;
  color: #4338ca;
  background: #eef2ff;
  font-size: 0.5625rem;
  font-weight: 800;
}

.ipt-document-detail__files strong {
  min-width: 0;
  color: #334155;
  font-size: 0.6875rem;
  overflow-wrap: anywhere;
}

.ipt-document-detail__files a {
  flex: 0 0 auto;
  color: #4338ca;
  font-size: 0.625rem;
  font-weight: 800;
}

.ipt-document-history--primary {
  border-top: 0;
  background: #fff;
}

.ipt-document-history__item.is-selected {
  border-color: #67e8f9;
  background: #ecfeff;
  box-shadow: inset 0.2rem 0 #0891b2;
}

@media (max-width: 760px) {
  .ipt-document-detail {
    padding: 1rem;
  }
  .ipt-document-detail__top,
  .ipt-document-detail__section-header,
  .ipt-document-detail__files li {
    align-items: flex-start;
    flex-direction: column;
  }
  .ipt-document-detail__meta {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .ipt-document-detail__quote-item {
    grid-template-columns: minmax(0, 1fr);
    gap: 0.25rem;
  }
  .ipt-document-detail__files li > div {
    align-items: flex-start;
    flex-direction: column;
  }
}
.ipt-delivery-section__tools {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.5rem;
}

.ipt-delivery-choice--files.is-selected {
  border-color: #a5b4fc;
  color: #4338ca;
  background: #eef2ff;
}

@media (max-width: 760px) {
  .ipt-delivery-section__tools {
    margin-left: 2.75rem;
  }
  .ipt-delivery-section__tools .ipt-delivery-choice,
  .ipt-delivery-section__tools .ipt-delivery-section__count {
    margin-left: 0;
  }
}
.ipt-document-history__card {
  overflow: hidden;
  margin-top: 0.5rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.65rem;
  background: #fff;
  transition: border-color 150ms ease, box-shadow 150ms ease;
}

.ipt-document-history__card:hover {
  border-color: #a5d8df;
}

.ipt-document-history__card.is-expanded {
  border-color: #67e8f9;
  box-shadow: inset 0.2rem 0 #0891b2, 0 8px 22px rgba(8, 145, 178, 0.06);
}

.ipt-document-history__card .ipt-document-history__item {
  margin-top: 0;
  border: 0;
  border-radius: 0;
}

.ipt-document-history__card.is-expanded .ipt-document-history__item {
  border-bottom: 1px solid #bae6fd;
  background: #ecfeff;
}

.ipt-document-history__title {
  display: flex;
  min-width: 0;
  align-items: center;
}

.ipt-document-history__meta {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.75rem;
}

.ipt-document-history__toggle {
  display: inline-flex;
  min-width: 4.25rem;
  align-items: center;
  justify-content: flex-end;
  gap: 0.35rem;
  color: #0e7490;
  font-size: 0.625rem;
  font-weight: 800;
}

.ipt-document-history__toggle i {
  font-size: 0.5625rem;
  transition: transform 150ms ease;
}

.ipt-document-history__card.is-expanded .ipt-document-history__toggle i {
  transform: rotate(180deg);
}

.ipt-document-history__detail {
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
  padding: 1rem;
  background: #fff;
}

@media (max-width: 760px) {
  .ipt-document-history__meta {
    width: 100%;
    align-items: flex-start;
    justify-content: space-between;
  }
  .ipt-document-history__detail {
    padding: 0.85rem;
  }
}`],
})
export class ComponentIpMarketDocumentsComponent implements OnInit, OnChanges {
    @Input() kind: string = 'sale';
    @Input() target: string = '';
    @Input() recipient: string = '';
    @Output() sent = new EventEmitter<void>();
    public items: any[] = [];
    public draft: any = this.empty();
    public mode: DocumentViewMode = 'compose';
    public busy = false;
    public loading = false;
    public error = '';
    public category = '세금계산서';
    private ready = false;
    private generation = 0;
    private dirty = false;
    private loadedContext = '';

    constructor(@Inject( Service) public service: Service) {}
    public async ngOnInit() {
        await this.service.init();
        this.ready = true;
        await this.load();
    }
    public async ngOnChanges() {
        if (this.ready && this.loadedContext !== this.contextKey()) await this.load();
    }
    private empty() {
        return { id: '', revision: 0, status: 'DRAFT', title: '거래 관련 서류', message: '',
            include_quote: true, include_files: true, files: [], quote: { recipient: this.recipient || '', issuer: '웅빈',
                title: 'IP 거래 업무 견적서', date: new Date().toLocaleDateString('sv-SE'), note: '',
                items: [{ name: '업무대행수수료', quantity: 1, price: 0, tax: 0 }] } };
    }
    private context() { return { kind: this.kind, target: this.target }; }
    private contextKey(ctx: any = this.context()) { return ctx.kind + ':' + ctx.target; }
    private same(ctx: any) { return ctx.kind === this.kind && ctx.target === this.target; }
    private consume(event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();
    }
    private async api(ctx: any, action: string, args: any = {}) {
        const res = await wiz.call('documents', { ...ctx, action, ...args });
        if (res.code !== 200) throw new Error(res.data?.error?.message || '서류 처리를 완료하지 못했습니다.');
        return res.data;
    }
    public async load() {
        const seq = ++this.generation;
        const ctx = this.context();
        this.loadedContext = this.contextKey(ctx);
        this.items = []; this.draft = this.empty(); this.mode = 'compose'; this.error = ''; this.loading = true; this.dirty = false;
        await this.service.render();
        try {
            const data = await this.api(ctx, 'list');
            if (seq !== this.generation) return;
            this.items = data.items || [];
            this.mode = this.items.length ? 'history' : 'compose';
        } catch (e: any) {
            if (seq === this.generation) this.error = e.message || '서류 목록을 불러오지 못했습니다.';
        } finally {
            if (seq === this.generation) this.loading = false;
            await this.service.render();
        }
    }
    public async newDraft(event?: Event) {
        this.consume(event);
        if (this.busy || this.loading) return;
        this.draft = this.empty();
        this.mode = 'compose';
        this.error = '';
        this.dirty = false;
        await this.service.render();
    }
    public async showHistory(event?: Event) {
        this.consume(event);
        if (this.busy || this.loading) return;
        this.draft = this.empty();
        this.mode = 'history';
        this.error = '';
        await this.service.render();
    }
    public isExpanded(row: any) {
        return this.mode === 'history' && !!row?.id && this.draft?.id === row.id;
    }
    public markDirty() { if (this.draft?.status === 'DRAFT') this.dirty = true; }
    public async toggleDelivery(kind: 'quote' | 'files', event?: Event) {
        this.consume(event);
        if (this.busy || this.loading || this.draft?.status !== 'DRAFT') return;
        if (kind === 'quote') this.draft.include_quote = !this.draft.include_quote;
        if (kind === 'files') this.draft.include_files = !this.draft.include_files;
        this.markDirty();
        await this.service.render();
    }
    public async edit(row: any, event?: Event) {
        this.consume(event);
        if (this.busy || this.loading) return;
        if (row.status === 'SENT' && this.isExpanded(row)) {
            await this.showHistory();
            return;
        }
        this.draft = JSON.parse(JSON.stringify({ ...row, include_quote: !!row.quote,
            include_files: row.include_files !== false, quote: row.quote || this.empty().quote }));
        this.mode = row.status === 'SENT' ? 'history' : 'compose';
        this.error = ''; this.dirty = false;
        await this.service.render();
    }
    private accept(row: any) {
        this.items = [row, ...this.items.filter(item => item.id !== row.id)];
        this.draft = JSON.parse(JSON.stringify({ ...row, include_quote: !!row.quote,
            include_files: row.include_files !== false, quote: row.quote || this.empty().quote }));
        this.mode = row.status === 'SENT' ? 'history' : 'compose';
        this.dirty = false;
    }
    public addItem() {
        if (this.draft.quote.items.length < 30) this.draft.quote.items.push({ name: '', quantity: 1, price: 0, tax: 0 });
    }
    public removeItem(index: number) {
        if (this.draft.quote.items.length > 1) this.draft.quote.items.splice(index, 1);
    }
    public total() {
        return this.draft.quote.items.reduce((sum: number, item: any) =>
            sum + Number(item.quantity || 0) * Number(item.price || 0) + Number(item.tax || 0), 0);
    }
    public money(value: number) { return new Intl.NumberFormat('ko-KR').format(value || 0); }
    public label(status: string) { return ({ DRAFT: '작성 중', SENT: '발송완료', UNKNOWN: '발송 결과 확인 필요' } as any)[status] || status; }
    public attachmentFilesRequired() {
        return this.draft?.include_files !== false && !this.draft?.files?.length;
    }
    public canDeliver() {
        if (this.attachmentFilesRequired()) return false;
        return !!this.draft?.include_quote
            || (this.draft?.include_files !== false && !!this.draft?.files?.length);
    }
    public deliveryActionLabel() {
        const quote = !!this.draft.include_quote;
        const filesSelected = this.draft.include_files !== false;
        const hasFiles = !!this.draft.files.length;
        if (filesSelected && !hasFiles) return '첨부 서류를 선택해주세요';
        if (quote && filesSelected) return '견적서·첨부 서류 함께 발송';
        if (quote) return '견적서만 발송';
        if (filesSelected) return '첨부 서류만 발송';
        return '발송할 문서 선택';
    }
    public documentSummary(row: any) {
        const parts = [];
        if (row?.quote) parts.push('견적서');
        if (row?.include_files !== false && row?.files?.length) parts.push('첨부 ' + row.files.length + '개');
        return parts.join(' · ') || '발송 문서 없음';
    }
    public url(row: any, file = 'quote') { return '/ip-market/documents/' + row.id + '/' + file; }
    private async run(operation: (ctx: any, snapshot: any) => Promise<any>, success = ''): Promise<any | null> {
        if (this.busy || this.loading) return null;
        const ctx = this.context();
        const snapshot = JSON.parse(JSON.stringify(this.draft));
        this.busy = true; this.error = '';
        await this.service.render();
        try {
            const row = await operation(ctx, snapshot);
            if (this.same(ctx)) {
                this.accept(row);
                if (success) await this.service.modal.success(success);
            }
            return row;
        } catch (e: any) {
            if (this.same(ctx)) this.error = e.message || '서류 처리를 완료하지 못했습니다.';
            return null;
        } finally {
            this.busy = false;
            await this.service.render();
        }
    }
    public async save() {
        await this.run((ctx, draft) => this.api(ctx, 'save', { payload: JSON.stringify(draft) }), '서류를 저장했습니다.');
    }
    public async upload(event: any) {
        const input = event.target as HTMLInputElement;
        const files = Array.from(input.files || []);
        input.value = '';
        if (!files.length) return;
        if (files.length + this.draft.files.length > 10 || files.some(file =>
            !file.size || file.size > 20 * 1024 * 1024 || !/\.(pdf|png|jpe?g|hwpx?|docx?|xlsx?)$/i.test(file.name))) {
            this.error = '최대 10개, 파일당 20MB 이내의 PDF·이미지·HWP·Word·Excel 파일을 선택해주세요.';
            return;
        }
        const category = this.category;
        await this.run(async (ctx, draft) => {
            let row = await this.api(ctx, 'save', { payload: JSON.stringify(draft) });
            if (this.same(ctx)) this.accept(row);
            for (const file of files) {
                const form = new FormData();
                Object.entries({ ...ctx, action: 'upload', id: row.id, category }).forEach(([key, value]) => form.append(key, String(value)));
                form.append('file', file);
                const res = await fetch(wiz.url('documents'), { method: 'POST', body: form, credentials: 'same-origin' });
                const data = await res.json();
                if (!res.ok || data.code !== 200) throw new Error(data.data?.error?.message || '첨부에 실패했습니다. 저장된 서류를 다시 불러와주세요.');
                row = data.data;
                if (this.same(ctx)) this.accept(row);
            }
            return row;
        });
    }
    public async remove(file: any) {
        await this.run(async (ctx, draft) => {
            const row = await this.api(ctx, 'save', { payload: JSON.stringify(draft) });
            if (this.same(ctx)) this.accept(row);
            return this.api(ctx, 'remove', { id: row.id, file_id: file.id });
        });
    }
    public hasPendingDelivery() {
        if (this.mode !== 'compose' || !this.canDeliver()) return false;
        return this.draft?.status === 'UNKNOWN'
            ? !!this.draft?.id
            : this.draft?.status === 'DRAFT' && (!!this.draft?.id || this.dirty);
    }
    public async send(confirm = true): Promise<boolean> {
        if (this.busy || this.loading) return false;
        if (!this.canDeliver()) {
            if (confirm) {
                await this.service.modal.error(
                    this.attachmentFilesRequired()
                        ? '첨부 서류를 포함하려면 파일을 선택하거나 첨부 서류 선택을 해제해주세요.'
                        : '견적서 또는 첨부 서류를 선택해주세요.'
                );
            }
            return false;
        }
        const ctx = this.context();
        const current = this.draft;
        if (confirm) {
            this.busy = true;
            const confirmed = await this.service.modal.show({ title: this.deliveryActionLabel(),
                message: this.recipient + '님이 수요자용 시스템에서 확인할 수 있도록 선택한 문서를 발송합니다.',
                action: '발송', cancel: '취소', status: 'warning', actionBtn: 'success' });
            this.busy = false;
            if (!confirmed || !this.same(ctx) || current !== this.draft) {
                await this.service.render();
                return false;
            }
        }
        const result = await this.run(async (context, draft) => {
            const row = draft.status === 'UNKNOWN' ? draft : await this.api(context, 'save', { payload: JSON.stringify(draft) });
            if (this.same(context)) this.accept(row);
            try {
                return await this.api(context, 'send', { id: row.id, revision: row.revision });
            } catch (error) {
                const latest = await this.api(context, 'list');
                const updated = latest.items.find((item: any) => item.id === row.id);
                if (updated && this.same(context)) this.accept(updated);
                throw error;
            }
        }, '수요자용 시스템으로 서류를 발송했습니다.');
        const delivered = !!result && this.same(ctx) && this.draft.status === 'SENT';
        if (delivered) this.sent.emit();
        return delivered;
    }
}

export default ComponentIpMarketDocumentsComponent;